<template>
    <v-dialog 
    v-model="form.create"
    >
    <v-card hover class="card-round pa-3">
      <!-- <v-layout justify-center=""> -->
        <!-- <v-flex xs8>  -->
          <v-form v-model="valid">
          <p class="subheading text-center pa-3">Formulieren aanmaken</p>


             
          </v-form>
        <!-- </v-flex> -->
      <!-- </v-layout> -->
      
      <forms-add-multiple-forms></forms-add-multiple-forms>

    </v-card>



  </v-dialog>    

</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      valid: false,
      rules: [v => !!v || "Verplicht veld"]
    };
  },
  computed: {
    ...mapState(["archive", "app", "form", "objects"])
  },
  methods: {
    ...mapMutations(["closeArchiveDialog"]),
    ...mapActions(["createForm"]),
    getItems(reference) {
      if (reference != "") {
        var object = this.form.templates.filter(
          item => item.reference == reference
        );
        return this.objects.filter(
          item => item.category.reference == object[0].object
        );
      }
    }
  }
};
</script>

<style scoped>
.card-round {
  min-height: 100px;
}
</style>


